import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff9149e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 2 }
const _hoisted_2 = { key: 3 }
const _hoisted_3 = { key: 4 }

import { ref } from 'vue';
import { useGrouperStore } from 'stores/GrouperStore';
import { CodeType } from 'src/contracts/codeType';
import {
    presentOnAdmissionDisplayMap,
    presentOnAdmissionMap,
    presentOnAdmissionsDisplayValues
} from 'src/common/poaUtll';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCode',
  props: {
    columns: {},
    type: {}
  },
  setup(__props: any) {

const props = __props;

const description = ref<string | undefined>(undefined)
const code = ref<string | undefined>(undefined);
const poa = ref<string>('');
const editing = ref(false);

function addRow(): void {
  if (!description.value) {
    return;
  }

  if (props.type === CodeType.Diagnosis) {
    useGrouperStore().addDiagnosisCode(code.value, description.value, poa.value);
  } else if (props.type === CodeType.Procedure) {
    useGrouperStore().addProcedureCode(code.value, description.value);
  } else {
    console.log('Unknown Code Type.')
  }

  clear();
}

function edit(value: boolean): void {
  editing.value = value;
}

function clear(): void {
  description.value = undefined;
  poa.value = '';
  code.value = undefined;
  editing.value = false;
}

function setPOA(poaValue: string) {
  poa.value = presentOnAdmissionDisplayMap[poaValue];
  addRow();
}

function poaLabel(): string {
    return poa.value ? presentOnAdmissionMap[poa.value] : 'Set POA';
}

function searchCodes(text: string) {
  description.value = useGrouperStore().searchCodes(text);
}

function alternateRow(): string {
  if (editing.value) {
    return 'editing-row'
  }
  else if (getRowCount() % 2 === 1) {
    return 'iodine-alternate-table-row';
  }
  return 'bg-white text-black'
}

function getRowCount(): number {
  if (props.type === CodeType.Diagnosis) {
    return useGrouperStore().diagnosisCodes?.length || 0;
  } else if (props.type === CodeType.Procedure) {
    return useGrouperStore().procedureCodes?.length  || 0;
  } else {
    return 0;
  }
}


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(alternateRow())
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
      return (_openBlock(), _createElementBlock("td", { key: index }, [
        (column.name === 'code')
          ? (_openBlock(), _createBlock(_component_q_input, {
              key: 0,
              dense: "",
              outlined: "",
              modelValue: code.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event)),
                searchCodes
              ],
              placeholder: "Add Code",
              onKeydown: _withKeys(_withModifiers(addRow, ["prevent"]), ["enter"]),
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (edit(true))),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (edit(false)))
            }, {
              append: _withCtx(() => [
                (!code.value || description.value)
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 0,
                      class: "q-pa-none",
                      name: "fa-solid fa-circle-plus",
                      onClick: addRow,
                      size: "16px"
                    }))
                  : _createCommentVNode("", true),
                (description.value === '' && code.value)
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 1,
                      class: "q-pa-none",
                      name: "fa-solid fa-circle-exclamation",
                      size: "16px"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "onKeydown"]))
          : (column.name === 'action')
            ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
                key: 1,
                "no-caps": "",
                dense: "",
                flat: "",
                round: "",
                class: "text-none",
                "dropdown-icon": "fa-solid fa-ellipsis-vertical",
                size: "sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_list, null, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { onClick: clear }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Clear Code")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_close_popup]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { onClick: addRow }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Add Code")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (column.name === 'description')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(description.value), 1))
              : (column.name === 'poa')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_q_btn_dropdown, {
                      label: poaLabel(),
                      class: "poa-dropdown",
                      onKeydown: _withKeys(_withModifiers(addRow, ["prevent"]), ["enter"]),
                      onFocus: edit,
                      size: "md"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(presentOnAdmissionsDisplayValues), (poa, poaIndex) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: poaIndex,
                                clickable: "",
                                onClick: ($event: any) => (setPOA(poa))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(poa), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["label", "onKeydown"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3))
      ]))
    }), 128))
  ], 2))
}
}

})